import { Consultation } from "@/interfaces/Consultation";
import KeyCloakService from "../api/KeyCloakService";
import { AppContext } from "@/config/AppContext";
import { convertToConsultation } from "./pipes/Mapper";

export default {
  async fetchConsultationsOfUser(userId: string): Promise<Consultation[]> {
    try {
      const headers = {
        Authorization: `Bearer ${KeyCloakService.GetAccessToken()}` || "",
      };
      const url =
        AppContext.getApiUrlPath() + "/consultations/history?userId=" + userId;
      const response = await fetch(url, {
        method: "GET",
        headers: headers,
        body: null,
      });
      console.log(response);
      if (!response.ok) {
        console.error("Unable to fetch consultations:" + response);
        throw new Error("Unable to fetch consultations");
      }
      const data = await response.json();
      const consultations = data.map((apiData: any) => convertToConsultation(apiData));
      return consultations;
    } catch (error) {
      throw new Error("Unable to fetch consultations");
    }
  },
  async fetchConsultationsOfDoctorAndPatient(doctorId: string, patientId: string): Promise<Consultation[]> {
    try {
      const headers = {
        Authorization: `Bearer ${KeyCloakService.GetAccessToken()}` || "",
      };
      const url =
        AppContext.getApiUrlPath() + "/consultations/history?userId=" + doctorId + "&anotherUserId=" + patientId;
      const response = await fetch(url, {
        method: "GET",
        headers: headers,
        body: null,
      });
      console.log(response);
      if (!response.ok) {
        console.error("Unable to fetch consultations:" + response);
        throw new Error("Unable to fetch consultations");
      }
      const data = await response.json();
      const consultations = data.map((apiData: any) => convertToConsultation(apiData));
      return consultations;
    } catch (error) {
      throw new Error("Unable to fetch consultations");
    }
  },
};
